import shortid from "shortid";
import { ListItemIcon, Menu, MenuItem } from "../../../../../components";
import {
  BoletoService,
  notification,
  PlugBoletoService
} from "../../../../../services";
import { responseErros } from "../../../../../utils";
import { boletosHelper } from "../../../../../helpers/boletos.helper";
import {
  statusValidosBaixa,
  statusValidosConsulta,
  statusValidosDescarte,
} from "../../../resources/constantes";

const MenuActions = ({
  anchorEl,
  setAnchorEl,
  dadosEmpresa,
  boletoSelecionado,
  buscarBoletos,
  setLoading,
}) => {
  const plugBoletoService = new PlugBoletoService();
  const boletoService = new BoletoService();
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "primary-add-actions-menu";

  const handleAddActionsClose = () => {
    setAnchorEl(null);
  };

  async function descartarBoleto(id, integradorId) {
    setLoading(true);
    const result = await plugBoletoService.descartarEmLote(
      [integradorId],
      dadosEmpresa.empresa.cnpjCpf,
    );
    if (result?._dados?._sucesso?.length) {
      const updateBody = [{ id, status: "DESCARTADO" }];
      const resultDelete = await boletoService.update(updateBody);
      if (!resultDelete.isAxiosError) {
        notification.sucessoGenericos("Boleto descartado com sucesso");
        await buscarBoletos();
      } else {
        responseErros(resultDelete);
      }
    } else {
      notification.alertaGenericos("Erro ao descartar boleto(s)");
    }
    setLoading(false);
  }

  async function baixarBoleto(integradorId) {
    setLoading(true);

    const result = await plugBoletoService.baixarEmLote(
      [integradorId],
      dadosEmpresa.empresa.cnpjCpf,
    );
    if (result?._dados?.situacao) {
      notification.sucessoGenericos(
        "Boleto encaminhado para processamento de baixa",
      );
    } else {
      notification.alertaGenericos("Erro ao processar baixa");
    }

    setLoading(false);
    setAnchorEl(null);
  }

  async function enviarEmail(boleto) {
    if (boleto.cliente.email) {
      try {
        setLoading(true);
        await boletosHelper.enviarEmail(boleto, boleto.cliente, dadosEmpresa);
      } catch (error) {
        notification.alertaGenericos(error?.message ?? "Erro interno do servidor");
      } finally {
        setLoading(false);
        setAnchorEl(null);
      }
    } else {
      notification.alertaGenericos("Este cliente não possui e-mail cadastrado");
    }
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        elevation={1}
        getContentAnchorEl={null}
        id={menuId}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        autoFocus={false}
        open={isMenuOpen}
        onClose={handleAddActionsClose}
        className="my-1"
      >
        {[
          <MenuItem
            className="m-1 p-3"
            onClick={async (event) => {
              event.stopPropagation();
              setLoading(true);
              await enviarEmail(boletoSelecionado);
              setLoading(false);
            }}
            disabled={!statusValidosConsulta.includes(boletoSelecionado?.status)}
            sx={{ height: 20, borderRadius: 5 }}
            key={shortid.generate()}
          >
            <ListItemIcon style={{ minWidth: 42 }}>
              <i className="ph-fill ph-envelope" style={{ fontSize: 18 }}></i>
            </ListItemIcon>
            Enviar Email
          </MenuItem>,
          <MenuItem
            className="m-1 p-3"
            onClick={async (event) => {
              event.stopPropagation();
              await descartarBoleto([boletoSelecionado.id]);
            }}
            disabled={!statusValidosDescarte.includes(boletoSelecionado?.status)}
            sx={{ height: 20, borderRadius: 5 }}
            key={shortid.generate()}
          >
            <ListItemIcon style={{ minWidth: 42 }}>
              <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
            </ListItemIcon>
            Cancelar Emissão
          </MenuItem>,
          <MenuItem
            className="m-1 p-3"
            onClick={async (event) => {
              event.stopPropagation();
              await baixarBoleto([boletoSelecionado.id]);
            }}
            disabled={!statusValidosBaixa.includes(boletoSelecionado?.status)}
            sx={{ height: 20, borderRadius: 5 }}
            key={shortid.generate()}
          >
            <ListItemIcon style={{ minWidth: 42 }}>
              <i className="ph-bold ph-file-x" style={{ fontSize: 18 }}></i>
            </ListItemIcon>
            Cancelar Registro
          </MenuItem>,
        ]}
      </Menu>
    </>
  );
};

export default MenuActions;
